import React from 'react';
import { VIEWBOX_LOGO, TRANSFORMA_LOGO, TRAZADO_LOGO } from '../lib/marcaGeovis';

/**
 * Logotipo oficial — «GEOVIS» con la rosa de los vientos en la O.
 * Geometría de lib/marcaGeovis.js (extraída del SVG oficial); el color sale de
 * `--marca` (= solar, el dorado de la rampa), igual que Logo.tsx de la landing
 * oficial: cambiar la marca es tocar una línea de index.css y nada más.
 * `sobreVideo`: sobre el héroe (siempre crepúsculo, ajeno al tema) el solar
 * claro del tema light desaparece — ahí se fija el solar luminoso del dark.
 */
export const GeovisLogo = ({ className, sobreVideo = false, ...props }) => (
  <svg
    viewBox={VIEWBOX_LOGO}
    className={className}
    role="img"
    aria-label="GeoVis"
    fill={sobreVideo ? 'oklch(0.80 0.125 98)' : 'oklch(var(--marca))'}
    {...props}
  >
    <g transform={TRANSFORMA_LOGO}>
      <path d={TRAZADO_LOGO} />
    </g>
  </svg>
);

export default GeovisLogo;
